import { HttpParams } from '@angular/common/http';

export function buildQueryParams<T extends Record<string, any>>(
  params: T
): HttpParams {
  let httpParams = new HttpParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      httpParams = httpParams.set(key, value.toString());
    }
  });

  return httpParams;
}
